import gsap from "gsap";

const 
filters = document.querySelectorAll(".filter"),
card = document.querySelectorAll(".carte-booking");  
  
const init = () => {
    filters.forEach(el => {
        el.addEventListener("click", () => {
            const current_filter = el.dataset.type
            document.querySelector(".filter.active").classList.remove("active");
            el.classList.add("active");
            if(current_filter === "tout"){
              gsap.to(card,{
                autoAlpha: 1,
                position: "relative"
              });
            }else if(current_filter){
                const card_to_hide = document.querySelectorAll(`.carte-booking:not(.${current_filter})`);
                const card_to_show = document.querySelectorAll(`.carte-booking.${current_filter}`);
                console.log(card_to_show);
                
                card_to_hide.length && gsap.to(card_to_hide, {
                    autoAlpha: 0,
                    position: "absolute"
                });
                card_to_show.length && gsap.to(card_to_show, {
                    autoAlpha: 1,
                    position: "relative"
                });
            }else{            
                gsap.to(card,{
                    autoAlpha: 1,
                    position: "relative"
                });
            }
        })
    })
};

document.addEventListener('DOMContentLoaded', () => {
    init();
});